import { jwtDecode } from "jwt-decode";
import axios from 'axios';
import router from '@/router'
import { store } from '@/store'


class User{
// export  default {
  constructor(){
    //this.CheckLoggedIn()
  }

  /*CheckLoggedIn(){
    store.state.loggedIn = this.loggedIn();
  }*/

  loggedIn(){let t,Val;
    if(!this.loadToken()){return Val;}
    try {  t = jwtDecode(this.loadToken()) }catch (e) {console.log('==',e)}
    if(t&&t.exp&&t.iat){Val = this.isTokenNotExpired(t.exp,t.iat); }else{Val = false;}
    if(!Val){localStorage.removeItem('token');}
    return Val;
  }

  subscribed(){ let t,Val;
    try {  t = jwtDecode(this.loadToken()) }catch (e) {console.log(e)}
    if(t.subscription){ Val =true;}
    return Val;
  }

  isTokenNotExpired(exp,iat){return  Date.now() < exp * 1000 && Date.now() > iat*1000;}

  logout(){
    console.log('==loggedOut=')
    localStorage.removeItem('token');
  }

  storeToken(token){ localStorage.setItem("token",token);}

  loadToken(){return localStorage.getItem("token"); }

  loadUser(){
    let token = this.loadToken();
    return token?jwtDecode(token):{};
  }


  getAxiosInstance(){
    const axiosInstance = axios.create({
      //baseURL: apiEndpoint,
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    axiosInstance.interceptors.response.use(
      (axiosResponse)=>{
      //console.log('=axiosResponse==',axiosResponse);
      return axiosResponse
    }, error => {
      const statusCode = error.response ? error.response.status : null;

      if (statusCode === 401) { // Unauthorized
        this.logout();
        store.state.toastr.open({timeOut:1000, type:"error", 
          title:'logged out ', text: 'Unauthorized!'});
        setTimeout(()=>{
          router.push({ path:'/' })
          router.go(0);
        },1000)
      }
    
      if (statusCode >= 500) {
        // show server error
      }
    
      if (statusCode === 400) {
        // show bad request error
      }

      if (statusCode === 402) { // Payment Required
        console.log('==statusCode==',statusCode)
      }

      return Promise.reject(error);
    });

    return axiosInstance;
  }

}

export default new User({})



// WEBPACK FOOTER //
// ./src/services/User.service.js